module.exports = __webpack_public_path__ + "img/slide4.b97bf6f0.svg";